namespace RioERP.Administration {
    export class UserColumns {
        static columnsKey = 'Administration.User';
    }
}
